<div class="share-label" [title]="securityType.class">
  <span class="class">{{ securityType.class }}</span><span [hidden]="hidePrice"
  class="paid-unpaid">&#64;{{ securityType.nominalPrice | currency : currency }}
  /{{ (securityType.unpaidAmount) | currency : currency }}</span>
  <ng-content></ng-content>
</div>
